import { useBonuses } from "@/app/composables/useBonus"
import { useGlobalLoader } from "@/app/composables/useGlobalLoader"
import { toast } from "@/app/utils/notification"
import { casinoGameInit } from "@/casino/api"
import { useAuth } from "@/user-account/composables/useAuth"
import { useUserService } from "@/user-account/composables/useUserService.ts"
import { ref } from "vue"

const { activeBonus } = useBonuses()

const { enableLoader } = useGlobalLoader()
const { isAuthenticated } = useAuth()
const { activeWallet } = useUserService()
const selectedCurrency = ref("USD")
const loading = ref(false)

const isGameSession = ref(false)

export function useGameHelper() {
  async function startGame(game, isDemo, handleLogin) {
    if (!isAuthenticated() && !isDemo) {
      handleLogin()
      return
    }
    enableLoader(3000)
    isGameSession.value = true
    loading.value = true

    // Get wallet id
    const walletId = activeWallet.value.id
    const isGameWithValue = game.id ? game : game.value

    const { data } = await casinoGameInit({
      gameId: isGameWithValue.id,
      walletId,
      isDemo,
      currency: selectedCurrency.value,
    })

    if (data.redirectUrl === null) {
      toast.warn(`This game can not be played${isDemo ? " in demo mode" : ""}`)
    }
    else {
      isGameWithValue.redirectUrl = data.redirectUrl
    }
    loading.value = false
  }

  return {
    startGame,
    isGameSession,
    selectedCurrency,
  }
}
